
  const __registry__ = require('../../../spiferack/client/index.js')
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var React = require('react');
var PropTypes = require('prop-types');
var _require = require('react-helmet'),
  Helmet = _require.Helmet;
var connect = require('../../components/connect');
var PackageListItem = require('../../components/package-list-item/package-list-item');
var Pagination = require('../../components/pagination/pagination');
var _require2 = require('@primer/react'),
  Dropdown = _require2.Dropdown,
  useDetails = _require2.useDetails;
var Octicon = require('@primer/octicons-react');
var _require3 = require('../../components/stack'),
  Stack = _require3.Stack;
var search = require('../../../client/actions/search');
var styles = require('./search.css');

// This needs to be lower than or equal to `ES_MAX_FROM` from `es-shim-server/lib/constants.js`
var NPM_SEARCH_MAX_RESULTS = 1000;
function Container(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, children);
}
var DEFAULT_SORT_ORDER = 'score';
/**
 * @type {Record<'score' | 'downloads_weekly' | 'downloads_monthly' | 'dependent_count' | 'published_at', string>}
 */
// The keys need to match `es-shim-server/lib/handlers/v3/index.js`
var SORT_ORDERS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DEFAULT_SORT_ORDER, 'Default'), "downloads_weekly", 'Most downloaded this week'), "downloads_monthly", 'Most downloaded this month'), "dependent_count", 'Most dependents'), "published_at", 'Recently published');
function SearchPage(_ref2) {
  var _formData$search, _formData$search$sort, _formData$search2;
  var total = _ref2.total,
    objects = _ref2.objects,
    url = _ref2.url,
    pagination = _ref2.pagination,
    formData = _ref2.formData,
    dispatch = _ref2.dispatch,
    error = _ref2.error,
    errorText = _ref2.errorText,
    errorCode = _ref2.errorCode;
  // focus the search element, place the cursor at the end
  React.useEffect(function () {
    /** @type {HTMLInputElement | null} */
    var searchInput = document.querySelector('input[name="search"]');
    if (searchInput) {
      searchInput.focus();
      searchInput.setSelectionRange(searchInput.value.length, searchInput.value.length);
    }
  }, []);
  var searchMaxPages = Math.ceil(NPM_SEARCH_MAX_RESULTS / pagination.perPage);
  var displayTotal = Math.min(total, pagination.perPage * searchMaxPages);
  var searchWord = (_formData$search = formData.search) === null || _formData$search === void 0 || (_formData$search = _formData$search.q) === null || _formData$search === void 0 ? void 0 : _formData$search.value;
  var searchResultsTruncated = total > NPM_SEARCH_MAX_RESULTS;

  /** @type {keyof typeof SORT_ORDERS} */
  var sortByOption = (_formData$search$sort = (_formData$search2 = formData.search) === null || _formData$search2 === void 0 || (_formData$search2 = _formData$search2.sortBy) === null || _formData$search2 === void 0 ? void 0 : _formData$search2.value) !== null && _formData$search$sort !== void 0 ? _formData$search$sort : DEFAULT_SORT_ORDER;
  var _useDetails = useDetails({}),
    getDetailsProps = _useDetails.getDetailsProps,
    setOpen = _useDetails.setOpen;
  var detailsProps = getDetailsProps();
  var dropdownItemFn = React.useCallback(function (key) {
    setOpen(false);
    dispatch({
      type: 'FORM_CHANGE',
      name: 'page',
      formId: 'search',
      value: String(0)
    });
    dispatch({
      type: 'FORM_CHANGE',
      name: 'sortBy',
      formId: 'search',
      value: key
    });
    dispatch(search());
  }, [dispatch]);
  if (error) {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, formData.search.q.value, " - npm search")), /*#__PURE__*/React.createElement(Stack, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement("h2", {
      className: styles.searchHeading
    }, "no possible matches!"), /*#__PURE__*/React.createElement("p", null, errorText)));
  }
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, formData.search.q.value, " - npm search")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: styles.srOnly
  }, "Search results"), /*#__PURE__*/React.createElement(Stack, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: styles.searchHeading
  }, displayTotal, searchResultsTruncated ? '+' : '', " ", displayTotal === 1 ? 'package' : 'packages', " found")), /*#__PURE__*/React.createElement(Dropdown, {
    open: detailsProps.open,
    onToggle: detailsProps.onToggle
  }, /*#__PURE__*/React.createElement(Dropdown.Button, {
    className: styles.dropdownButton,
    sx: {
      borderRadius: 3,
      border: '1px solid var(--search-border)',
      backgroundColor: 'var(--search-bg-subtle)',
      padding: '6px 8px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.dropdownLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.dropdownPrefix
  }, "Sort by: "), /*#__PURE__*/React.createElement("span", {
    className: styles.dropdownSelected
  }, SORT_ORDERS[sortByOption]))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: styles.dropdownMenu,
    sx: {
      width: 'auto',
      minWidth: '100%',
      borderRadius: 3,
      border: '1px solid var(--search-border)',
      padding: '4px 4px !important',
      // @primer has an important style that we need to override
      boxShadow: '0px 2px 4px 0px #0000001F'
    }
  }, Object.keys(SORT_ORDERS).map(function (k) {
    var value = /** @type {keyof typeof SORT_ORDERS} */k; // typecast because we're not using proper Typescript
    var label = SORT_ORDERS[value];
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: value,
      value: value,
      label: label,
      sortByOption: sortByOption,
      onClick: dropdownItemFn
    });
  })))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, objects.map(function (_ref3) {
    var _ref4, _pkg$downloads, _pkg$downloads2;
    var pkg = _ref3.package,
      score = _ref3.score;
    return /*#__PURE__*/React.createElement(PackageListItem, {
      key: pkg.name,
      package: pkg,
      score: score,
      searchWord: searchWord,
      search: true
      //
      // TODO: remove `hidePQM` and `newSearchEnabled` when search has been rolled out
      ,
      hidePQM: true,
      newSearchEnabled: true,
      downloads: (_ref4 = sortByOption === 'downloads_weekly' ? (_pkg$downloads = pkg.downloads) === null || _pkg$downloads === void 0 ? void 0 : _pkg$downloads.weekly : (_pkg$downloads2 = pkg.downloads) === null || _pkg$downloads2 === void 0 ? void 0 : _pkg$downloads2.monthly) !== null && _ref4 !== void 0 ? _ref4 : 0
    });
  })), objects.length > 0 && displayTotal > pagination.perPage && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.pagination
  }, /*#__PURE__*/React.createElement(Pagination, {
    url: url,
    perPage: pagination.perPage,
    page: pagination.page,
    total: displayTotal,
    surround: 2
  })))));
}
SearchPage.propTypes = {
  objects: PropTypes.arrayOf(PropTypes.shape({
    package: PropTypes.object.isRequired
  })).isRequired,
  partners: PropTypes.arrayOf(PropTypes.object),
  hidePQM: PropTypes.bool
};
function DropdownItem(_ref5) {
  var value = _ref5.value,
    label = _ref5.label,
    sortByOption = _ref5.sortByOption,
    _onClick = _ref5.onClick;
  return /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return _onClick(value);
    },
    sx: {
      borderRadius: 3,
      '&:hover': {
        backgroundColor: 'var(--search-bg-subtle)'
      },
      padding: '4px 10px 4px 4px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.dropdownItemInner
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.dropdownIcon
  }, value === sortByOption && /*#__PURE__*/React.createElement(Octicon.CheckIcon, {
    verticalAlign: "middle",
    className: styles.selectedIcon
  })), /*#__PURE__*/React.createElement("span", null, label)));
}
module.exports = connect()(SearchPage);
  let __hot__
  
  __registry__.register('searchv2/search', module.exports, __hot__)
  